import SessionStore from '@/stores/SessionStore'

/*
  returns true if user has access to element
 */
export default function hasPermission(roles, userRoles) {
  if (!userRoles) {
    userRoles = SessionStore.state.roles;
  }
  return roles.includes('ALL') || roles.some(role => userRoles.includes(role));
}